import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow, colors } from '@material-ui/core';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles } from '@material-ui/styles';
import formatPrice from 'src/utils/formatPrice';
import { metersToKm, secToMin } from 'src/utils/helper';
import TripStatus from './TripStatus';

const useStyles = makeStyles(() => ({
  nowrap: {
    whiteSpace: 'nowrap'
  }
}));

export default function TripRow({ trip, hover, ...props }) {
  const classes = useStyles();
  const { firstName = '', lastName = '' } = trip.driver || trip.user || {};
  // ponytail: /pages/admin-view/dashboard returns raw trip docs with no driver
  // object, only userId — show a short id so the column is never blank.
  const driverName =
    [firstName, lastName].filter(Boolean).join(' ') ||
    trip.driverName ||
    (trip.userId ? trip.userId.slice(0, 8) : '—');
  return (
    <TableRow
      hover={hover}
      style={{ cursor: hover ? 'pointer' : 'auto' }}
      {...props}
    >
      <TableCell className={classes.nowrap}>{driverName}</TableCell>

      <TableCell>{trip.availableSeats}</TableCell>
      <TableCell>{metersToKm(trip.distance)}</TableCell>
      <TableCell>{trip.totalSeats}</TableCell>
      <TableCell>{secToMin(trip.duration)}</TableCell>
      <TableCell>{trip.departureDate}</TableCell>
      <TableCell>{trip.departureTime}</TableCell>
      <TableCell className={classes.nowrap}>
        {formatPrice(trip.pricing, trip.pricingCurrency)}
      </TableCell>
      <TableCell size="smalls">
        <TripStatus status={trip.tripStatus} />
      </TableCell>
      <TableCell align="center">
        {trip.verified ? (
          <VerifiedUserIcon style={{ color: colors.green[500] }} />
        ) : (
          <WarningIcon style={{ color: colors.red[500] }} />
        )}
      </TableCell>
    </TableRow>
  );
}

TripRow.propTypes = {
  trip: PropTypes.object.isRequired,
  hover: PropTypes.bool
};
